var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    fill: "none",
    viewBox: "0 0 6 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M.327 1.83a.4.4 0 0 1 0-.565L.66.931a.5.5 0 0 1 .707 0L5.22 4.784a.3.3 0 0 1 0 .424l-.547.546a.3.3 0 0 1-.424 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M.327 8.162a.4.4 0 0 0 0 .566l.334.334a.5.5 0 0 0 .707 0L5.22 5.21a.3.3 0 0 0 0-.424l-.547-.546a.3.3 0 0 0-.424 0z"
  })));
};
export default SvgChevronRight;